<template>
  <div v-loading="loading">
    <a-row>
      <a-col
        :span="24"
        :lg="24"
        :xl="24"
        class="mb-24"
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <a-radio-group
          v-model:value="dateType"
          button-style="solid"
          @change="dateTypeChange"
          size="small"
        >
          <a-radio-button value="1">周</a-radio-button>
          <a-radio-button value="2">月</a-radio-button>
          <a-radio-button value="3">年</a-radio-button>
          <a-radio-button value="4">全部</a-radio-button>
        </a-radio-group>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :span="24" :lg="24" :sm="24" :xs="24">
        <div class="my-charts" ref="myChart"></div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { getChartKeyWordBottomChart } from "@/api/charts";
import { WCIOptions, WCITKOptions } from "./KeywordChartOpt";
export default {
  data() {
    return {
      loading: true,
      isMobile: false,
      receivedId: null,
      dateType: "1",
      chart: null,
      KeywordWciData: [],
      
      KeywordTkData: [],
      KeyWord: "",
      xAxisData: [],
      yAxisData: [],
      adScore: [],
      extlinkScore: [],
      liveScore: [],
      mpdocScore: [],
      queryScore: [],
      scoreExp: [],
      w1wScore: [],
      finderScore: [],
      totalScore: [],
      tkSearchScore: [],
      tkTopScore: [],

      Series: [],
      ChartDataZoom: [],
      ChartGrid: [],
      ChartLegend: [],
      WCIxAxisData: [],
      TkxAxisData: [],
    };
  },
  created() {
    this.receivedId = this.$route.query.id || null;
  },
  methods: {
    SetData(wciData, tkData) {
      this.KeywordWciData = wciData;
      this.KeywordTkData = tkData;
      this.GetDate();
    },
    GetDate() {
      this.loading = true; // 开始加载
      this.Series = [];
      this.SetWciChartData();

      if (this.KeywordTkData.length > 0) {
        this.SetTkChartData();
        this.ChartDataZoom = WCITKOptions.DataZoom;
        this.ChartGrid = WCITKOptions.Grid;
        this.ChartLegend = WCITKOptions.Legend;
        this.xAxisData = WCITKOptions.xAxis;
        this.xAxisData[0].data = this.WCIxAxisData
        this.xAxisData[1].data = this.TkxAxisData;
        this.yAxisData = WCITKOptions.yAxis;
      } else {
        this.ChartDataZoom = WCIOptions.DataZoom;
        this.ChartGrid = WCIOptions.Grid;
        this.ChartLegend = WCIOptions.Legend;
        this.xAxisData = WCIOptions.xAxis;
        this.xAxisData[0].data = this.WCIxAxisData;
        this.yAxisData = WCIOptions.yAxis;
      }

      this.InitOptions();
    },

    SetWciChartData() {
      var ChartData = [];
      if (this.dateType == "1") {
        ChartData = this.KeywordWciData.slice(
          this.KeywordWciData.length - 7,
          this.KeywordWciData.length
        );
      } else if (this.dateType == "2") {
        ChartData = this.KeywordWciData.slice(
          this.KeywordWciData.length - 30,
          this.KeywordWciData.length
        );
      } else if (this.dateType == "3") {
        ChartData = this.KeywordWciData.slice(
          this.KeywordWciData.length - 365,
          this.KeywordWciData.length
        );
      } else {
        ChartData = this.KeywordWciData;
      }
      this.KeyWord = ChartData[0].keyWord;
      this.WCIxAxisData = ChartData.map((item) => item.infoTime);

      this.adScore = ChartData.map((item) => item.adScore);
      this.extlinkScore = ChartData.map((item) => item.extlinkScore);
      this.liveScore = ChartData.map((item) => item.liveScore);
      this.mpdocScore = ChartData.map((item) => item.mpdocScore);
      this.queryScore = ChartData.map((item) => item.queryScore);
      this.scoreExp = ChartData.map((item) => item.scoreExp);
      this.totalScore = ChartData.map((item) => item.totalScore);
      this.w1wScore = ChartData.map((item) => item.w1wScore);
      this.finderScore = ChartData.map((item) => item.finderScore);
      this.Series.push({
        name: "WCI广告",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(128, 255, 165)",
            },
            {
              offset: 1,
              color: "rgb(1, 191, 236)",
            },
          ]),
        },
        emphasis: {
          focus: "series",
        },
        data: this.adScore,
      });
      this.Series.push({
        name: "WCI外链",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(0, 221, 255)",
            },
            {
              offset: 1,
              color: "rgb(77, 119, 255)",
            },
          ]),
        },
        emphasis: {
          focus: "series",
        },
        data: this.extlinkScore,
      });
      this.Series.push({
        name: "WCI直播",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(55, 162, 255)",
            },
            {
              offset: 1,
              color: "rgb(116, 21, 219)",
            },
          ]),
        },
        emphasis: {
          focus: "series",
        },
        data: this.liveScore,
      });
      this.Series.push({
        name: "WCI公众号",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(255, 0, 135)",
            },
            {
              offset: 1,
              color: "rgb(135, 0, 157)",
            },
          ]),
        },
        emphasis: {
          focus: "series",
        },
        data: this.mpdocScore,
      });
      this.Series.push({
        name: "WCI搜一搜",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        label: {
          show: true,
          position: "top",
        },
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(255, 191, 0)",
            },
            {
              offset: 1,
              color: "rgb(224, 62, 76)",
            },
          ]),
        },

        emphasis: {
          focus: "series",
        },
        data: this.queryScore,
      });
      this.Series.push({
        name: "WCI问一问",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        label: {
          show: true,
          position: "top",
        },
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(125, 191, 0)",
            },
            {
              offset: 1,
              color: "rgb(125, 62, 76)",
            },
          ]),
        },

        emphasis: {
          focus: "series",
        },
        data: this.w1wScore,
      });
      this.Series.push({
        name: "WCI视频号",
        type: "line",
        stack: "Total",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        label: {
          show: true,
          position: "top",
        },
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(255, 191, 0)",
            },
            {
              offset: 1,
              color: "rgb(224, 62, 76)",
            },
          ]),
        },

        emphasis: {
          focus: "series",
        },
        data: this.finderScore,
      });
    },
    
    SetTkChartData() {
      var ChartData = [];
      if (this.dateType == "1") {
        ChartData = this.KeywordTkData.slice(
          this.KeywordTkData.length - 7,
          this.KeywordTkData.length
        );
      } else if (this.dateType == "2") {
        ChartData = this.KeywordTkData.slice(
          this.KeywordTkData.length - 30,
          this.KeywordTkData.length
        );
      } else if (this.dateType == "3") {
        ChartData = this.KeywordTkData.slice(
          this.KeywordTkData.length - 365,
          this.KeywordTkData.length
        );
      } else {
        ChartData = this.KeywordTkData;
      }
      this.TkxAxisData = ChartData.map((item) => item.infoTime);

      this.tkSearchScore = ChartData.map((item) => item.searchScore);
      this.tkTopScore = ChartData.map((item) => item.topScore);

      this.Series.push({
        name: "TK搜索",
        type: "line",
        stack: "Total1",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        label: {
          show: true,
          position: "top",
        },
        xAxisIndex: 1,
        yAxisIndex: 1,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(125, 191, 0)",
            },
            {
              offset: 1,
              color: "rgb(125, 62, 76)",
            },
          ]),
        },

        emphasis: {
          focus: "series",
        },
        data: this.tkSearchScore,
      });
      this.Series.push({
        name: "TK综合",
        type: "line",
        stack: "Total1",
        smooth: true,
        lineStyle: {
          width: 0,
        },
        showSymbol: false,
        label: {
          show: true,
          position: "top",
        },
        xAxisIndex: 1,
        yAxisIndex: 1,
        areaStyle: {
          opacity: 0.8,
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(255, 191, 0)",
            },
            {
              offset: 1,
              color: "rgb(224, 62, 76)",
            },
          ]),
        },

        emphasis: {
          focus: "series",
        },
        data: this.tkTopScore,
      });
    },
    dateTypeChange() {
      this.GetDate();
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },

    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      this.chart.setOption({
        title: {
          text: this.KeyWord,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 10,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          formatter: (params) => {
            if (!params || params.length === 0) return "";

            // 使用div包裹所有内容，添加基本样式
            let result = `<div style="padding: 8px;">`;

            // 添加标题，使用粗体和更大的字号
            result += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">${params[0].name}</div>`;

            // 过滤并处理上图数据
            const wciTopParams = params.filter((item) => item.axisIndex === 0);
            if (wciTopParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = wciTopParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              wciTopParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      WCI总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 过滤并处理下图数据，如果存在则添加分隔线和数据
            const wciBomParams = params.filter((item) => item.axisIndex === 1);
            if (wciBomParams.length > 0) {
              // 如果同时有上图数据，添加分隔线
              if (wciTopParams.length > 0) {
                result += `<div style="margin: 8px 0; border-top: 2px solid #f0f0f0;"></div>`;
              }

              // 添加每个数据项
              wciBomParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                 "WCI-" + item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });
            }

            if (this.KeywordTkData.length > 0) {
              result += `<div style="margin: 15px 0; border-top: 5px solid #f0f0f0;"></div>`;
              const tkTopParams = params.filter((item) => item.axisIndex === 2);
              if (tkTopParams.length > 0) {
                // 计算总计值，添加安全检查
                const total = tkTopParams.reduce(
                  (sum, item) => sum + (parseFloat(item.value) || 0),
                  0
                );
                // 添加每个数据项
                tkTopParams.forEach((item) => {
                  const value = parseFloat(item.value) || 0;
                  result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                    item.seriesName
                  }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
                });
                // 添加分隔线和总计，使用不同的样式突出显示
                result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      TK总计
      <span>${total.toLocaleString()}</span>
    </div>`;
              }

              const tkBomParams = params.filter((item) => item.axisIndex === 3);
              if (tkBomParams.length > 0) {
                if (tkTopParams.length > 0) {
                  result += `<div style="margin: 8px 0; border-top: 2px solid #f0f0f0;"></div>`;
                }
                // 添加每个数据项
                tkBomParams.forEach((item) => {
                  const value = parseFloat(item.value) || 0;
                  result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                   "TK-" + item.seriesName
                  }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
                });
              }
            }
            // 关闭外层div
            result += `</div>`;
            return result;
          },
        },
        axisPointer: {
          link: [
            {
              xAxisIndex: "all",
            },
          ],
          label: {
            backgroundColor: "#777",
          },
        },
        grid: this.ChartGrid,
        legend: this.ChartLegend,
        dataZoom: this.ChartDataZoom,
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: this.xAxisData,
        yAxis: this.yAxisData,
        series: this.Series,
      });
      this.loading = false;
    },
    checkScreenSize() {
      const width = window.innerWidth;
      // 假设sm断点为576px，xs断点为320px
      // 具体值可根据项目的响应式设计调整
      this.isMobile = width <= 992;
    },
    handleTagClick(item) {
      this.loading = true;
      getChartKeyWordBottomChart(item.id).then((res) => {
        if (res.code == 0) {
          this.TypeWciData = res.data;
          this.GetDate();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.checkScreenSize();
  },
};
</script>

<style lang="scss" scoped>
.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 40vh; // 设置固定高度，可根据需要调整
}

.tag-container-mobile {
  height: 200px !important;
}

/* 或者使用媒体查询方式 */
@media screen and (max-width: 576px) {
  .tag-container {
    height: 200px !important;
  }
}
</style>